var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"icon-title title__medium"},[(!_vm.$slots['icon'])?_c('span',{staticClass:"material-symbols-outlined"},[_vm._v(_vm._s(_vm.materialIcon))]):_vm._t("icon"),_vm._v(" "+_vm._s(_vm.title)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }